import React from "react";
import { useNavigate } from "react-router-dom";
import "./userModals.css";

const AuthPrompt = ({
  open,
  title,
  message,
  primaryLabel,
  primaryPath,
  secondaryLabel,
  secondaryPath,
  onClose,
}) => {
  const navigate = useNavigate();

  if (!open) {
    return null;
  }

  const goTo = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="ib-modal-overlay" onClick={onClose}>
      <div
        className="ib-modal-card"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="ib-modal-accent" />
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="ib-modal-actions">
          {secondaryLabel && secondaryPath ? (
            <button
              type="button"
              className="ib-modal-btn ghost"
              onClick={() => goTo(secondaryPath)}
            >
              {secondaryLabel}
            </button>
          ) : null}
          {primaryLabel && primaryPath ? (
            <button
              type="button"
              className="ib-modal-btn primary"
              onClick={() => goTo(primaryPath)}
            >
              {primaryLabel}
            </button>
          ) : null}
        </div>
        {onClose ? (
          <button type="button" className="ib-modal-close" onClick={onClose}>
            Close
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default AuthPrompt;
